/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Shortcuts_DescriptionInputs */

const he_help_shortcuts_description = /** @type {(inputs: Help_Shortcuts_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נווטו מהר יותר עם קיצורי מקלדת.`)
};

const en_help_shortcuts_description = /** @type {(inputs: Help_Shortcuts_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigate faster with keyboard shortcuts.`)
};

/**
* | output |
* | --- |
* | "Navigate faster with keyboard shortcuts." |
*
* @param {Help_Shortcuts_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const help_shortcuts_description = /** @type {((inputs?: Help_Shortcuts_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Shortcuts_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_help_shortcuts_description(inputs)
	return en_help_shortcuts_description(inputs)
});